import GoToBackArrow from "../../components/GoToBackArrow";
import {useEffect, useState} from "react";
import "./index.css";
import {Link, useNavigate} from "react-router-dom";
import {API_BASE_URL} from "../../config";
import pencilLogo from "../../images/svg/pencil_icon.svg";

const OrderList = () => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [ error, setError ] = useState(null);
    const navigate = useNavigate();
    const telegramUserId = sessionStorage.getItem('telegramUserId');

    useEffect(() => {
        const fetchOrders = async () => {
            setLoading(true)
            setError(null)

            try {
                // Получаем список специалистов
                const response = await fetch(`${API_BASE_URL}/api/order/orders/${telegramUserId}/`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    credentials: "include"
                });

                if (!response.ok) {
                    throw new Error("Network response was not ok " + response.statusText);
                }

                setOrders(await response.json());

            } catch (err) {
                console.error("Fetch error:", err);
                setError(err.message);
            } finally {
                setLoading(false)
            }
        };

        fetchOrders();

    }, []);

    return (
        <div className="order_list_page page_bg">
            <GoToBackArrow backUrl='/'/>
            <div className="content_title">
                <span>Ваши записи</span>
            </div>
            {error && <div style={{color: 'red'}}>{error}</div>}
            {loading ? <>Загрузка записей...</> : (
                <div className="order_list">
                    {!orders.length ? <>Нет записей</> : orders.map((order) => (
                        <div key={order.id} className="order_list__item">
                            Услуга: {order.service.name}<br/>
                            Мастер: {order.specialist_fio}<br/>
                            Время: {order.time} {order.date}<br/>
                            <Link to={`/manage-booking/${order.id}`} className={'order_list__item__edit_btn'}>
                                <img src={pencilLogo} alt="" className="pencilLogo"/>
                            </Link>
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}

export default OrderList;